import React from 'react'
import GeneralModal from './GeneralModal'

export default ({ setShowModal, children }) => (
  <GeneralModal name={'Exitstitial'} onClick={e => setShowModal(false)} informational={true}>
    {children}
  </GeneralModal>
)
